/* cs-handoff.js · handoff v18 (09.09.2026) — scoped behaviours for the CS chrome and the five editorial pages.
   Everything is bound through data-cs-* attributes; nothing global is touched (no generic dialog/tablist/anchor hooks).
   Idempotent: safe to load more than once and safe under the Theme Editor's section reloads. */
(function () {
  'use strict';
  if (window.__csHandoff) { window.__csHandoff.init(); return; }
  var doc = document, root = doc.documentElement;
  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false, addEventListener: function () {} };
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var filmCompact = window.matchMedia ? window.matchMedia('(max-width: 749px)') : {matches: false};
  var userFilm = null;
  var activeModal = null;
  var bound = new WeakSet();
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function once(el, key) { var k = '__cs_' + key; if (el[k]) return false; el[k] = true; return true; }

  /* ───────── Dialogs ───────── */
  function pauseAllFilms() { $$('[data-cs-film] video').forEach(function (v) { if (!v.paused) v.pause(); }); }
  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.open) return;
    dialog.__opener = opener || doc.activeElement;
    dialog.__navigating = false;
    activeModal = dialog;
    pauseAllFilms();
    dialog.showModal();
    // Hotfix 09.09.2026: showModal() moves focus to the first link (the drawer logo) and iOS paints the focus ring around it;
    // focus the dialog container instead (still inside the dialog for assistive tech; Esc / focus trap unchanged).
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    try { dialog.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    root.classList.add('cs-dialog-open');
    if (opener && opener.hasAttribute('aria-expanded')) opener.setAttribute('aria-expanded', 'true');
  }
  function closeDialog(dialog) { if (dialog && dialog.open) dialog.close(); }
  function bindDialog(dialog) {
    if (!once(dialog, 'dlg')) return;
    if (dialog.id === 'cs-mobile-menu') {
      dialog.addEventListener('pointerdown', function () { dialog.__pointerInteraction = true; }, { passive: true });
      dialog.addEventListener('keydown', function () { dialog.__pointerInteraction = false; });
    }
    dialog.addEventListener('click', function (e) {
      var r = dialog.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside && e.target === dialog) closeDialog(dialog);
    });
    if (dialog.matches('.c-mega-dialog, .c-mobile-dialog')) {
      dialog.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('a[href]');
        if (!link || !dialog.contains(link) || e.defaultPrevented || e.button !== 0 ||
            e.metaKey || e.ctrlKey || e.shiftKey || e.altKey ||
            link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        var href = (link.getAttribute('href') || '').trim();
        if (!href || href === '#' || /^javascript:/i.test(href)) return;
        dialog.__navigating = true;
        closeDialog(dialog);
        if (!$('dialog.c-dlg[open]')) root.classList.remove('cs-dialog-open');
      }, true);
    }
    dialog.addEventListener('close', function () {
      if (dialog.open) return;
      if (dialog.id === 'cs-mobile-menu') settleMenuDisclosures(dialog);
      var v = $('video', dialog);
      if (v && dialog.classList.contains('c-film-dialog')) { v.pause(); v.removeAttribute('src'); v.load(); }
      if (activeModal === dialog) activeModal = null;
      if (!$('dialog.c-dlg[open]')) root.classList.remove('cs-dialog-open');
      var op = dialog.__opener;
      if (dialog.id === 'cs-mobile-menu' && op) {
        // Keep focus restoration; suppress only the pointer-return ring on iOS.
        if (dialog.__pointerInteraction) op.setAttribute('data-cs-pointer-focus', '');
        else op.removeAttribute('data-cs-pointer-focus');
      }
      if (op && op.hasAttribute && op.hasAttribute('aria-expanded')) op.setAttribute('aria-expanded', 'false');
      if (!dialog.__navigating && op && typeof op.focus === 'function' && doc.contains(op)) { try { op.focus({ preventScroll: true }); } catch (e) { op.focus(); } }
      syncFilms();
    });
    $$('[data-cs-close]', dialog).forEach(function (b) { if (once(b, 'close')) b.addEventListener('click', function () { closeDialog(dialog); }); });
    $$('a[href^="#"]', dialog).forEach(function (a) {
      if (!once(a, 'anchor')) return;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1); var target = id && doc.getElementById(id);
        if (!target) return;
        e.preventDefault(); closeDialog(dialog); scrollToTarget(target);
      });
    });
  }
  function scrollToTarget(target) {
    target.scrollIntoView({ behavior: motion.matches ? 'auto' : 'smooth', block: 'start' });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (e) { /* noop */ }
  }
  function bindOpeners() {
    $$('[data-cs-open]').forEach(function (b) {
      if (!once(b, 'open')) return;
      if (b.getAttribute('data-cs-open') === 'cs-mobile-menu') {
        ['blur', 'keydown'].forEach(function (type) {
          b.addEventListener(type, function () { b.removeAttribute('data-cs-pointer-focus'); });
        });
      }
      b.addEventListener('click', function () { openDialog(doc.getElementById(b.getAttribute('data-cs-open')), b); });
    });
  }
  var mobileNav = window.matchMedia ? window.matchMedia('(max-width: 1099.98px)') : null;
  if (mobileNav && mobileNav.addEventListener) mobileNav.addEventListener('change', function () { settleMenuDisclosures(); $$('dialog.c-mega-dialog[open], dialog.c-mobile-dialog[open]').forEach(closeDialog); });

  /* Measured mobile disclosures: interruptible, no DOM wrapper, native fallback when motion is reduced. */
  var submenuStates = new Map(), submenuNames = new WeakMap(), submenuReveal = null;
  function menuDisclosures(){return $$('#cs-mobile-menu details');}
  const curve='cubic-bezier(.22,1,.36,1)';
  /* Reveal only a user-opened group, inside the drawer, after sibling/ancestor motion settles. */
  function cancelMenuReveal(){if(submenuReveal){cancelAnimationFrame(submenuReveal.frame);submenuReveal=null;}}
  function currentMenuReveal(request){
   if(submenuReveal!==request)return false;
   if(!request.menu.open||!doc.contains(request.menu)||!request.menu.contains(request.detail))return false;
   for(let d=request.detail;d&&request.menu.contains(d);d=d.parentElement&&d.parentElement.closest('details')){
    const state=submenuStates.get(d);if(state?!state.expand:!d.open)return false;
   }
   return true;
  }
  function menuRevealGeometry(request){
   const menu=request.menu,rect=menu.getBoundingClientRect(),viewport=window.visualViewport;
   const viewportTop=viewport?viewport.offsetTop:0,viewportBottom=viewportTop+(viewport?viewport.height:window.innerHeight);
   const top=Math.max(rect.top+menu.clientTop,viewportTop)+12;
   const bottom=Math.min(rect.top+menu.clientTop+menu.clientHeight,viewportBottom)-12;
   const summary=request.detail.querySelector(':scope>summary').getBoundingClientRect(),detail=request.detail.getBoundingClientRect();
   return {top,bottom,start:summary.top,end:detail.bottom,scroll:menu.scrollTop,max:Math.max(0,menu.scrollHeight-menu.clientHeight)};
  }
  function scrollMenuReveal(request,geometry){
   const menu=request.menu,available=geometry.bottom-geometry.top;
   let delta=0;
   if(available<=0){cancelMenuReveal();return;}
   if(geometry.end-geometry.start>available||geometry.start<geometry.top)delta=geometry.start-geometry.top;
   else if(geometry.end>geometry.bottom)delta=geometry.end-geometry.bottom;
   const from=geometry.scroll,to=Math.max(0,Math.min(geometry.max,from+delta));
   if(Math.abs(to-from)<1){cancelMenuReveal();return;}
   if(motion.matches){menu.scrollTop=to;cancelMenuReveal();return;}
   let started;
   function step(time){
    if(!currentMenuReveal(request)){if(submenuReveal===request)cancelMenuReveal();return;}
    if(started===undefined)started=time;
    const progress=Math.min(1,(time-started)/260);
    menu.scrollTop=from+(to-from)*(1-Math.pow(1-progress,3));
    if(progress<1)request.frame=requestAnimationFrame(step);else cancelMenuReveal();
   }
   request.frame=requestAnimationFrame(step);
  }
  function queueMenuReveal(detail){
   cancelMenuReveal();
   const menu=detail.closest('#cs-mobile-menu');if(!menu||!menu.open)return;
   const request={menu,detail,frame:0,geometry:null};submenuReveal=request;
   function settled(){
    if(!currentMenuReveal(request)){if(submenuReveal===request)cancelMenuReveal();return;}
    if(Array.from(submenuStates.keys()).some(d=>menu.contains(d))){request.geometry=null;request.frame=requestAnimationFrame(settled);return;}
    const geometry=menuRevealGeometry(request),previous=request.geometry;
    request.geometry=geometry;
    if(!previous||Object.keys(geometry).some(key=>Math.abs(geometry[key]-previous[key])>.5)){request.frame=requestAnimationFrame(settled);return;}
    scrollMenuReveal(request,geometry);
   }
   request.frame=requestAnimationFrame(settled);
  }
  function submenuMotionEnabled(){return !motion.matches&&typeof Element.prototype.animate==='function';}
  function syncDisclosure(detail,expanded){const summary=detail.querySelector(':scope>summary');summary.setAttribute('aria-expanded',String(expanded));detail.dataset.csSubmenuExpanded=String(expanded);}
  function cleanDisclosure(detail,state){state.animation.cancel();state.rows.forEach(a=>a.cancel());detail.open=state.expand;detail.style.removeProperty('height');detail.style.removeProperty('overflow');submenuStates.delete(detail);syncDisclosure(detail,detail.open);}
  function heightMotion(detail,state,from,to,duration){
   state.targetHeight=to;detail.style.height=from+'px';
   state.animation=detail.animate([{height:from+'px'},{height:to+'px'}],{duration,easing:curve});
   state.animation.onfinish=()=>{if(submenuStates.get(detail)===state)cleanDisclosure(detail,state);};
  }
  function animateDisclosure(detail,expand){
   const summary=detail.querySelector(':scope>summary'),old=submenuStates.get(detail),wasOpen=detail.open;
   if(old&&old.expand===expand)return;
   const height=detail.getBoundingClientRect().height,oldTarget=old?old.targetHeight:height;
   const ancestors=[];for(let a=detail.parentElement.closest('details');a;a=a.parentElement.closest('details')){const s=submenuStates.get(a);if(s&&s.expand)ancestors.push([a,s,a.getBoundingClientRect().height]);}
   const bodies=Array.from(detail.children).filter(e=>e!==summary);
   const items=bodies.length===1&&bodies[0].children.length?Array.from(bodies[0].children):bodies;
   const visuals=items.map(item=>{const cs=getComputedStyle(item);return{item,opacity:cs.opacity,transform:cs.transform};});
   if(old){old.animation.cancel();old.rows.forEach(a=>a.cancel());}
   detail.style.height='auto';detail.open=true;
   const openHeight=detail.getBoundingClientRect().height,cs=getComputedStyle(detail);
   const shutHeight=summary.getBoundingClientRect().height+parseFloat(cs.paddingTop)+parseFloat(cs.paddingBottom)+parseFloat(cs.borderTopWidth)+parseFloat(cs.borderBottomWidth);
   const target=expand?openHeight:shutHeight,duration=expand?360:220;
   detail.style.overflow='hidden';
   const state={expand,animation:null,rows:[],targetHeight:target};submenuStates.set(detail,state);syncDisclosure(detail,expand);
   for(const [a,s,current]of ancestors){s.animation.cancel();heightMotion(a,s,current,s.targetHeight+target-oldTarget,duration);}
   heightMotion(detail,state,height,target,duration);
   visuals.forEach(({item,opacity,transform},i)=>{const from=!wasOpen&&!old?{opacity:.55,transform:'translateY(12px)'}:{opacity,transform};const to=expand?{opacity:1,transform:'translateY(0)'}:{opacity:.55,transform:'translateY(-4px)'};state.rows.push(item.animate([from,to],{duration:expand?280:180,delay:expand?Math.min(i*20,80):0,easing:curve,fill:'both'}));});
  }
  function configureDisclosures(){
   var menu=doc.getElementById('cs-mobile-menu');if(!menu)return;
   if(submenuMotionEnabled())menu.setAttribute('data-cs-submenu-motion','');else menu.removeAttribute('data-cs-submenu-motion');
   for(const d of menuDisclosures()){
    if(!submenuNames.has(d))submenuNames.set(d,d.getAttribute('name'));
    const name=submenuNames.get(d);
    if(submenuMotionEnabled())d.removeAttribute('name');else if(name)d.setAttribute('name',name);
    const state=submenuStates.get(d);syncDisclosure(d,state?state.expand:d.open);
   }
  }
  function bindMenuDisclosures(){
   configureDisclosures();
   const menu=doc.getElementById('cs-mobile-menu');
   if(menu&&once(menu,'submenuReveal')){
    ['wheel','touchstart','touchmove','pointerdown'].forEach(type=>menu.addEventListener(type,cancelMenuReveal,{passive:true}));
    menu.addEventListener('keydown',cancelMenuReveal);
   }
  for(const detail of menuDisclosures()){
   if(!once(detail,'submenuMotion'))continue;
   const summary=detail.querySelector(':scope>summary');
   detail.addEventListener('toggle',()=>{if(!submenuStates.has(detail))syncDisclosure(detail,detail.open);});
   summary.addEventListener('click',e=>{
    cancelMenuReveal();
    const old=submenuStates.get(detail),expand=old?!old.expand:!detail.open;
    if(!submenuMotionEnabled()){if(expand)queueMenuReveal(detail);return;}
    e.preventDefault();
    if(expand){const name=submenuNames.get(detail);if(name)for(const peer of menuDisclosures()){const state=submenuStates.get(peer);if(peer!==detail&&submenuNames.get(peer)===name&&(state?state.expand:peer.open))animateDisclosure(peer,false);}}
    animateDisclosure(detail,expand);
    if(expand)queueMenuReveal(detail);
   });
  }
  }
  function settleMenuDisclosures(scope){if(submenuReveal&&(!scope||scope.contains(submenuReveal.detail)))cancelMenuReveal();for(const [d,s]of Array.from(submenuStates)){if(!scope||scope.contains(d))cleanDisclosure(d,s);}}
  window.addEventListener('resize',cancelMenuReveal);
  if(window.visualViewport){window.visualViewport.addEventListener('resize',cancelMenuReveal);window.visualViewport.addEventListener('scroll',cancelMenuReveal);}
  if(motion.addEventListener)motion.addEventListener('change',function(){settleMenuDisclosures();configureDisclosures();});

  /* ───────── Invitation bar (black line above the header) ───────── */
  function bindInvitation() {
    var bar = $('[data-cs-invitation]');
    if (!bar || !once(bar, 'inv')) return;
    bar.addEventListener('click', function (e) {
      var href = bar.getAttribute('href') || '';
      if (href.charAt(0) === '#') { var t = doc.getElementById(href.slice(1)); if (t) { e.preventDefault(); scrollToTarget(t); } }
    });
    if (window.csDiscoveryBooking) window.csDiscoveryBooking.refresh();
  }

  /* ───────── Films (muted loops that play only in view) ───────── */
  var visibility = new Map(), observer = null;
  function filmSource(v, mp4, hls) { return hls && v.canPlayType('application/vnd.apple.mpegurl') ? hls : mp4; }
  function filmCandidates(v, mp4, hls, fallback) { return [filmSource(v, mp4, hls), mp4, fallback].filter(function (url, index, all) { return url && all.indexOf(url) === index; }); }
  function isPlaybackError(v) { return v.error && (v.error.code === 2 || v.error.code === 3 || v.error.code === 4); }
  function rememberFilmTime(v, next) {
    v.__csFilmRestore = { source: next, time: Number.isFinite(v.currentTime) ? v.currentTime : 0, rate: v.playbackRate };
  }
  function bindFilmTimeRestore(v) {
    if (!once(v, 'filmTimeRestore')) return;
    v.addEventListener('loadedmetadata', function () {
      var restore = v.__csFilmRestore;
      if (!restore || v.getAttribute('src') !== restore.source) return;
      v.__csFilmRestore = null;
      v.__csFilmSwitching = false;
      var end = Number.isFinite(v.duration) ? Math.max(0, v.duration - 0.001) : restore.time;
      try { v.currentTime = Math.min(restore.time, end); } catch (e) { /* unavailable seek range */ }
      if (Number.isFinite(restore.rate) && restore.rate > 0) v.playbackRate = restore.rate;
    });
  }
  function syncFilmDialogVisibility() {
    var full = activeModal && activeModal.classList.contains('c-film-dialog') && $('video', activeModal);
    if (!full || !full.__csFilmVerifiedFallback) return;
    if (doc.hidden) {
      full.__csFilmVisibilityPaused = true;
      if (!full.paused) full.pause();
    } else if (full.__csFilmVisibilityPaused) {
      full.__csFilmVisibilityPaused = false;
      if (full.__csFilmShouldPlay && !full.__csFilmExhausted) {
        var resumed = full.play(); if (resumed && resumed.catch) resumed.catch(function () {});
      }
    }
  }
  function ensureSrc(v) { if (!v.getAttribute('src') && v.dataset.src) { v.src = filmSource(v, v.dataset.src, v.dataset.hls); v.load(); } }
  function mayAutoplay(v) { return v.dataset.userPlay === 'true' || !(motion.matches || saveData); }
  function syncFilms() {
    var playing = 0;
    var videos = $$('[data-cs-film] video').sort(function (a, b) { return Number(b === userFilm) - Number(a === userFilm) || (visibility.get(b) || 0) - (visibility.get(a) || 0); });
    videos.forEach(function (v) {
      var ratio = visibility.get(v) || 0;
      var should = ratio > 0.2 && playing < (filmCompact.matches ? 1 : 2) && v.dataset.userPaused !== 'true' && !doc.hidden && !activeModal && mayAutoplay(v) && v.dataset.failed !== 'true';
      if (should) {
        playing++; ensureSrc(v);
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () { /* autoplay refused: poster stays */ }); }
      } else if (!v.paused) { v.pause(); }
      var fig = v.closest('[data-cs-film]'); var btn = fig && $('[data-cs-video-toggle]', fig);
      if (btn) setToggle(btn, v);
    });
  }
  function setToggle(btn, v) {
    var playing = !v.paused && !v.ended;
    btn.textContent = playing ? 'Ⅱ' : '▶';
    btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }
  function bindFilms() {
    if (!observer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visibility.set(en.target, en.isIntersecting ? en.intersectionRatio : 0); });
        syncFilms();
      }, { threshold: [0, 0.2, 0.5, 0.8, 1] });
    }
    $$('[data-cs-film]').forEach(function (fig) {
      if (!once(fig, 'film')) return;
      var v = $('video', fig); if (!v) return;
      if (observer) observer.observe(v);
      bindFilmTimeRestore(v);
      v.addEventListener('error', function () {
        if (v.dataset.failed === 'true') return;
        if (v.dataset.fallbackVerified === 'true') {
          if (!isPlaybackError(v)) return;
          var fallback = v.dataset.fallback;
          if (v.__csFilmFallbackTried || !fallback || fallback === v.getAttribute('src')) { v.dataset.failed = 'true'; v.pause(); return; }
          v.__csFilmFallbackTried = true;
          rememberFilmTime(v, fallback);
          v.src = fallback; v.load(); syncFilms(); return;
        }
        var candidates = filmCandidates(v, v.dataset.src, v.dataset.hls, v.dataset.fallback);
        var next = candidates[candidates.indexOf(v.getAttribute('src')) + 1];
        if (!next) { v.dataset.failed = 'true'; v.pause(); return; }
        v.src = next; v.load(); syncFilms();
      });
      var toggle = $('[data-cs-video-toggle]', fig), open = $('[data-cs-video-open]', fig);
      if (toggle) toggle.addEventListener('click', function () {
        ensureSrc(v);
        if (v.paused) { v.dataset.userPaused = 'false'; v.dataset.userPlay = 'true'; userFilm = v; if (filmCompact.matches) $$('[data-cs-film] video').forEach(function (other) { if (other !== v) other.pause(); }); var p = v.play(); if (p && p.catch) p.catch(function () { /* noop */ }); }
        else { v.dataset.userPaused = 'true'; v.pause(); }
        setToggle(toggle, v);
      });
      v.addEventListener('play', function () { if (toggle) setToggle(toggle, v); });
      v.addEventListener('pause', function () { if (toggle) setToggle(toggle, v); });
      if (open) open.addEventListener('click', function () {
        var dlg = doc.getElementById('cs-film-dialog'); if (!dlg) return;
        var full = $('video', dlg); if (!full) return;
        var mp4 = v.dataset.full || v.dataset.src;
        var fallback = v.dataset.full ? v.dataset.fullFallback : v.dataset.fallback;
        full.__csFilmVerifiedFallback = (v.dataset.full ? v.dataset.fullFallbackVerified : v.dataset.fallbackVerified) === 'true';
        full.__csFilmCandidates = full.__csFilmVerifiedFallback ? [mp4, fallback].filter(function (url, index, all) { return url && all.indexOf(url) === index; }) : filmCandidates(full, mp4, v.dataset.full ? v.dataset.fullHls : v.dataset.hls, fallback);
        full.__csFilmExhausted = false;
        full.__csFilmVisibilityPaused = false;
        full.__csFilmRestore = null;
        bindFilmTimeRestore(full);
        full.__csFilmIndex = 0;
        full.__csFilmShouldPlay = true;
        var selected = full.__csFilmCandidates[0];
        if (once(full, 'filmFallback')) {
          full.addEventListener('play', function () { full.__csFilmShouldPlay = true; if (full.__csFilmVerifiedFallback) full.__csFilmSwitching = false; });
          full.addEventListener('pause', function () { if (!full.error && !full.__csFilmSwitching && !full.__csFilmVisibilityPaused) full.__csFilmShouldPlay = false; });
          full.addEventListener('error', function () {
            if (activeModal !== dlg || (full.__csFilmVerifiedFallback && (!isPlaybackError(full) || full.__csFilmExhausted))) return;
            var next = (full.__csFilmCandidates || [])[++full.__csFilmIndex];
            if (!next) { full.__csFilmExhausted = true; full.__csFilmShouldPlay = false; full.pause(); return; }
            var resume = full.__csFilmShouldPlay && !doc.hidden;
            if (full.__csFilmVerifiedFallback) rememberFilmTime(full, next);
            full.__csFilmSwitching = true; full.src = next; full.load(); if (!full.__csFilmVerifiedFallback) full.__csFilmSwitching = false;
            if (resume) { var retry = full.play(); if (retry && retry.catch) retry.catch(function () {}); }
          });
        }
        full.src = selected; full.muted = false; full.currentTime = 0;
        openDialog(dlg, open);
        var p = full.play(); if (p && p.catch) p.catch(function () { /* user gesture may be required */ });
      });
    });
    syncFilms();
  }
  doc.addEventListener('visibilitychange', syncFilms);
  doc.addEventListener('visibilitychange', syncFilmDialogVisibility);
  if (motion.addEventListener) motion.addEventListener('change', syncFilms);
  if (filmCompact.addEventListener) filmCompact.addEventListener('change', syncFilms);
  if (navigator.connection && navigator.connection.addEventListener) navigator.connection.addEventListener('change', function () { saveData = !!navigator.connection.saveData; syncFilms(); });

  /* ───────── Rails ───────── */
  function bindRails() {
    $$('[data-cs-rail-wrap]').forEach(function (wrap) {
      if (!once(wrap, 'rail')) return;
      var rail = $('[data-cs-rail]', wrap), prev = $('[data-cs-rail-prev]', wrap), next = $('[data-cs-rail-next]', wrap);
      if (!rail) return;
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (prev) prev.disabled = rail.scrollLeft <= 1;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      function go(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: motion.matches ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      rail.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(update); ro.observe(rail); resizeObservers.push({ el: rail, ro: ro }); } else window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ───────── Tabs ───────── */
  function bindTabs() {
    $$('[data-cs-tabs]').forEach(function (list) {
      if (!once(list, 'tabs')) return;
      var tabs = $$('[role="tab"]', list);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
          var pane = doc.getElementById(t.getAttribute('data-cs-tab')); if (pane) pane.hidden = !on;
        });
        if (focus) tab.focus();
        bindRails();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length]; else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0]; else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ───────── Grid ───────── UX-01 (09.09.2026): the grid renders every product of the current page visible; further pages are
     appended by assets/cs-listing.js (native pagination as fallback). The former click-gated reveal is gone. */
  function bindGrids() { /* intentionally empty — kept so older call sites stay valid */ }

  /* ───────── Photo lightbox ───────── */
  function bindPhotos() {
    var dlg = doc.getElementById('cs-photo-dialog'); if (!dlg) return;
    var img = $('img', dlg), status = $('.c-photo-loading', dlg);
    $$('[data-cs-photo]').forEach(function (b) {
      if (!once(b, 'photo')) return;
      b.addEventListener('click', function () {
        img.hidden = true; if (status) { status.hidden = false; status.textContent = status.getAttribute('data-loading') || ''; }
        img.onload = function () { img.hidden = false; if (status) status.hidden = true; };
        img.onerror = function () { if (status) { status.textContent = status.getAttribute('data-error') || ''; } };
        img.alt = b.getAttribute('data-alt') || ''; img.src = b.getAttribute('data-cs-photo');
        openDialog(dlg, b);
      });
    });
  }

  /* ───────── Gift Card · occasions + message helpers ───────── */
  function giftTextarea() {
    var f = $('form[data-cs-lead-form]'); if (!f) return null;
    var el = $('textarea', f);
    if (el && !doc.getElementById('gift-message')) {
      var oldId = el.id, lab = oldId ? $('label[for="' + oldId + '"]', f) : null;
      el.id = 'gift-message';
      if (lab) lab.setAttribute('for', 'gift-message'); // revizie 09.09.2026 (C): keep the native label association
      // Gift message limit (300 characters, revizie 09.09.2026 C) — UI constraint only; the frozen form section is untouched
      if (!el.getAttribute('maxlength')) {
        el.setAttribute('maxlength', '300');
        var cnt = doc.createElement('span'); cnt.className = 'c-gift-count'; cnt.setAttribute('aria-live', 'polite');
        var upd = function () { cnt.textContent = el.value.length + ' / 300'; };
        el.addEventListener('input', upd); upd(); el.insertAdjacentElement('afterend', cnt);
      }
    }
    return el;
  }
  function bindGift() {
    $$('[data-cs-gift-occasions]').forEach(function (sec) {
      if (!once(sec, 'gift')) return;
      var buttons = $$('[data-cs-gift-category]', sec), cards = $$('[data-cs-gift-kind]', sec);
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var cat = b.getAttribute('data-cs-gift-category');
          buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cards.forEach(function (c) { c.hidden = !(cat === 'all' || c.getAttribute('data-cs-gift-kind') === cat); });
        });
      });
      $$('[data-cs-gift-message]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          var ta = giftTextarea(); if (!ta) return;
          ta.value = b.getAttribute('data-cs-gift-message') || '';
          ta.dispatchEvent(new Event('input', { bubbles: true }));
          scrollToTarget(ta.closest('.shopify-section') || ta);
          try { ta.focus({ preventScroll: true }); ta.setSelectionRange(ta.value.length, ta.value.length); } catch (e) { /* noop */ }
        });
      });
      giftTextarea();
    });
  }

  /* ───────── Occasion preset (page → next CS Form instance); the contract allow-list is untouched ───────── */
  function presetOccasion() {
    $$('[data-cs-occasion]').forEach(function (src) {
      var sec = src.closest('.shopify-section'); var next = sec && sec.nextElementSibling;
      var sel = next && $('form[data-cs-lead-form] select[name="cs_ui_lead_occasion"]', next);
      if (!sel || sel.value) return;
      var code = src.getAttribute('data-cs-occasion');
      if (!Array.prototype.some.call(sel.options, function (o) { return o.value === code; })) return;
      sel.value = code; sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ───────── Footer groups ───────── */
  var compact = window.matchMedia ? window.matchMedia('(max-width: 760px)') : null;
  function setFooterGroups() { $$('[data-cs-footer-group]').forEach(function (d) { d.open = !(compact && compact.matches); }); }
  if (compact && compact.addEventListener) compact.addEventListener('change', setFooterGroups);

  var resizeObservers = [];
  function unloadSection(root) { // shopify:section:unload — release observers bound inside the removed section (revizie 09.09.2026)
    if (!root) return;
    settleMenuDisclosures(root);
    if (observer) $$('[data-cs-film] video', root).forEach(function (v) { observer.unobserve(v); visibility.delete(v); });
    resizeObservers = resizeObservers.filter(function (r) { if (root.contains(r.el)) { r.ro.disconnect(); return false; } return true; });
  }
  /* (a) preview context: keep view / preview_theme_id / sort_by on filter and pagination links (client-side only, never in canonical) */
  function keepPreviewParams() {
    var sp = new URLSearchParams(location.search), keep = [];
    ['view', 'preview_theme_id', 'sort_by'].forEach(function (k) { if (sp.get(k)) keep.push([k, sp.get(k)]); });
    if (!keep.length) return;
    $$('[data-cs-keep-params] a, .cs-pagination a').forEach(function (a) {
      if (!once(a, 'keep')) return;
      try { var u = new URL(a.getAttribute('href'), location.href); if (u.origin !== location.origin) return; keep.forEach(function (kv) { if (!u.searchParams.has(kv[0])) u.searchParams.set(kv[0], kv[1]); }); a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) { /* noop */ }
    });
  }
  function init() {
    keepPreviewParams();
    $$('dialog.c-dlg').forEach(bindDialog);
    bindOpeners(); bindMenuDisclosures(); bindInvitation(); bindFilms(); bindRails(); bindTabs(); bindGrids(); bindPhotos(); bindGift(); presetOccasion();
    if (!bound.has(doc)) { bound.add(doc); setFooterGroups(); }
  }
  window.__csHandoff = { init: init, sync: syncFilms };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
  doc.addEventListener('shopify:section:unload', function (e) { unloadSection(e.target); });
})();


